import "../Styles/registration-confirmation.css";

(function ($) {
    "use strict";

    if (typeof ori != "object") return;

    var self = null,
// ReSharper disable InconsistentNaming
        $activationFormContainer = $(".js-activation-form-container"),
        PASSWORD_INPUT = "input.js-new-password",
        ACTIVATION_FORM = ".js-activation-form",
        ACTIVATION_PASSWORD_FORM = ".js-password-confirmation-form",
        RESEND_ACTIVATION_CODE = ".resend-activation-code",
        RESEND_ACTIVATION_CODE_RESULT = ".js-resend-activation-code-result",
        CONSULTANT_NUMBER_INPUT = "input.js-consultant-number",
        ACTIVATION_CODE_INPUT = "input.js-activation-code",

        HIDDEN_CLASS = "hidden",

        START_EXPLORING_BUTTON = ".js-start-exploring-button",

        DATA_CUSTOM_VALIDATION = "data-val-customJSValidation",
        VALIDATION_ERROR = ".field-validation-error",

        validator;

    ori.consultants.addModule("confirmation", {
        init: function (options) {
            self.setOptions(options);
            setupForms();

            $("body").on("click", START_EXPLORING_BUTTON, function (e) {
                e.preventDefault();
                const myPagesLink = $(this).attr("data-my-pages-link");
                if (myPagesLink) {
                    window.location.href = myPagesLink;
                }
            });
        }
    });

    function onConfirmActivation(_, response) {
        if (response.result.activated) {
            window.location.href = response.result.url;
        }

        $activationFormContainer.html(response.result);
        setupForms();
    }

    function onConfirmActivationPassword(_, response) {
        const result = response.result;
        if (typeof result.username === "undefined") {
            if (result.activated) {
                window.location.href = result.url;
            }

            $activationFormContainer.html(result);
            setupForms();
        } else {
            const params = {Username: result.username, Password: $(PASSWORD_INPUT).val()};
            autoLogin(result.autoLoginUrl, params);
        }
    }

    function autoLogin(path, parameters) {
        var form = $('<form></form>');
    
        form.attr("method", "post");
        form.attr("action", path);
    
        $.each(parameters, function(key, value) {
            var field = $('<input></input>');
    
            field.attr("type", "hidden");
            field.attr("name", key);
            field.attr("value", value);
    
            form.append(field);
        });
        
        $(document.body).append(form);
        form.submit();
    }

    function setupForms() {
        setupActivationForm();
        setupActivationPasswordForm();
        validator = $(ACTIVATION_FORM).kendoValidator().data("kendoValidator");
        registerResendHandlers();
    }

    function setupActivationForm() {
        var formElement = document.querySelector(ACTIVATION_FORM);
        if (!formElement) {
            return;
        }
        ori.formFactory.create(formElement, {
            callbackOnSuccess: onConfirmActivation,
            isValidatorUsed: true,
        });
    }

    function setupActivationPasswordForm() {
        var formElement = document.querySelector(ACTIVATION_PASSWORD_FORM);
        if (!formElement) {
            return;
        }
        ori.formFactory.create(formElement, {
            callbackOnSuccess: onConfirmActivationPassword,
            isValidatorUsed: true,
            validatorOptions: {
                showErrorSummary: true,
            },
        });
        ori.passwordComponentFactory.createAll();
    }

    function registerResendHandlers() {
        var $resendButton = $(RESEND_ACTIVATION_CODE);

        if (!$resendButton.length) {
            return;
        }

        $resendButton.on(self.eventString("click"), function (e) {
            e.preventDefault();
            resendActivationCode();
            $(RESEND_ACTIVATION_CODE).prop('disabled', true);
            setTimeout(function () {
                $(RESEND_ACTIVATION_CODE).prop('disabled', false);
            }, 30000);

        });

        $(CONSULTANT_NUMBER_INPUT).on(self.eventString("change"), function (e) {
            removeValidationError($(this));
        });
    }

    function resendActivationCode() {
        var $form = $(ACTIVATION_FORM);
        ori.spinner.applyOverlayTo($form);

        if (!resetErrorsBeforeResend()) {
            ori.spinner.removeOverlayFrom($form);
            return;
        }

        var $resendActivationCodeResult = $(RESEND_ACTIVATION_CODE_RESULT);
        $resendActivationCodeResult.toggleClass(HIDDEN_CLASS, true);
        var $consultantNumberInput = $(CONSULTANT_NUMBER_INPUT);

        $.post(self.options.url.resendActivationCode, { consultantNumber: $consultantNumberInput.val() })
            .done(function (response) {
                if (!response.Success) {
                    setValidationError($consultantNumberInput, response.Message);
                } else {
                    $resendActivationCodeResult.html(response.Message);
                    $resendActivationCodeResult.toggleClass(HIDDEN_CLASS, false);
                }
            })
            .always(function() {
                ori.spinner.removeOverlayFrom($form);
            });
    }

    function resetErrorsBeforeResend() {
        var $activationCodeInput = $(ACTIVATION_CODE_INPUT);
        $activationCodeInput.val(" ");
        removeValidationError($activationCodeInput);
        $activationCodeInput.val("");

        return removeValidationError($(CONSULTANT_NUMBER_INPUT));
    }

    function setValidationError($input, errorMsg) {
        $input.nextAll(VALIDATION_ERROR).remove();
        $input.attr("data-val", true);
        $input.attr(DATA_CUSTOM_VALIDATION, errorMsg);
        validator.validateInput($input);
    }

    function removeValidationError($input) {
        $input.removeAttr(DATA_CUSTOM_VALIDATION);
        $input.nextAll(VALIDATION_ERROR).remove();
        return validator.validateInput($input);
    }

    self = ori.consultants.confirmation;

})(jQuery);
